import axios from 'axios';
// import {  ElMessage } from 'element-plus';
// import cookie from 'vue-cookie'

// 获取当前设备类型：h5 / pc
const getDevice = () => {
  return window.matchMedia('(max-width: 750px)').matches ? 'h5' : 'pc'
}

// 获取设备唯一标识：优先取本地已存，否则生成并持久化
const getDeviceId = () => {
  const key = 'hongy_device_id'
  let deviceId = localStorage.getItem(key)
  if (!deviceId) {
    deviceId =
      typeof crypto !== 'undefined' && crypto.randomUUID
        ? crypto.randomUUID()
        : 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
            const r = (Math.random() * 16) | 0
            const v = c === 'x' ? r : (r & 0x3) | 0x8
            return v.toString(16)
          })
    localStorage.setItem(key, deviceId)
  }
  return deviceId
}

const axiosFn = function (baseUrl) {

  const instance = axios.create({
    timeout: 1000000,
    baseURL: baseUrl,
    headers: {

    }
  });
  //请求拦截
  instance.interceptors.request.use(
    (config) => {
      config.headers['device'] = getDevice()
      config.headers['deviceId'] = getDeviceId()
      return config;
    },
    (err) => {
      return Promise.reject(err);
    }
  );

  //响应拦截
  instance.interceptors.response.use(
    (response) => {
        return response.data;
    },
    (error) => {
      return Promise.reject(error);
    }
  );
  return instance;
};

const baseURL = process.env.VUE_APP_API_BASEURL

export const api = axiosFn(baseURL);

export { getDevice, getDeviceId }
